import requestAction from '../../utils/requestAction'

export const fetchTeacher = (teacherId: string, handleResponse?: (response: any) => void) =>
  requestAction('REMOTE_TEACHER_DETAIL')(`remote-teachers/${teacherId}`, 'GET',
    undefined,
    (_dispatch, _getState, response) => { if (response && handleResponse) handleResponse(response) })
